import { Button, Typography } from '@mui/material';
import { Link } from "react-router-dom";
import { requestoauthApi } from "../services/authApi"
import { useState, useEffect } from "react";
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import DoneIcon from '@mui/icons-material/Done';
import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import FilledInput from '@mui/material/FilledInput';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import FormControl from '@mui/material/FormControl';
import SaveIcon from '@mui/icons-material/Save';
import { getregistertokenApi, setReferralCodeApi, checkUsernameValidApi, ChangeUserNameApi } from "../services/authApi"
import { checkRefferlCodeForUseApi } from "../services/marketingApi";
import { customToastify, checkErrorMessage, checkResponseData } from "../components/pages/utils/utilsFunctions"
import { ToastContainer, toast } from "react-toastify";
import { setPasswordApi } from "../services/authApi"
import CircularProgress from '@mui/material/CircularProgress';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';

const DemoPaper = styled(Paper)(({ theme }) => ({
  width: "95%",
  // height: 120,
  padding: theme.spacing(2),
  ...theme.typography.body2,
  textAlign: 'center',
}));


const LogedInUser = ({ authUserinfo, hanleAuthUserinfo }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordRepeat, setShowPasswordRepeat] = useState(false);
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [errorPassword, setErrorPassword] = useState(null);
  const [userName, setUserName] = useState(false);
  const [marketingCode, setMarketingCode] = useState("");
  const [message, setMessage] = useState({
    status: false,
    marketingCode: "",
    message: "",
  });

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => { event.preventDefault() };
  const handleClickShowPasswordRepeat = () => setShowPasswordRepeat((show) => !show);
  const handleMouseDownPasswordRepeat = (event) => { event.preventDefault() };
  const handlechangeUserName = (e) => {
    setUserName(e.target.value)
  }
  const checkUsernameValid = async () => {
    // const toastMsg = toast.loading("لطفا صبر کنید...")

    try {
      const response = await toast.promise(checkUsernameValidApi({ newUsername: userName }), {
        pending: "لطفا صبر کنید",
        success: "نام کاربری معتبر می باشد",
        error: "مشکلی وجود دارد 🤯",
      });
    } catch (error) {
      const errData = checkErrorMessage(error);
      customToastify("error", errData["titles"] || errData["message"], 5000, "top-center");
      console.error(error);
    }
  };

  const changeUserName = async () => {
    // const toastMsg = toast.loading("لطفا صبر کنید...")

    try {
      const response = await toast.promise(ChangeUserNameApi({ newUsername: userName }), {
        pending: "لطفا صبر کنید",
        success: "نام کاربری با موفقیت تغییر کرد",
        error: "مشکلی در بارگزاری اطلاعات وجود دارد 🤯",
      });
      const resData = checkResponseData(response);
      if (resData["success"]) {
        if (resData["data"]["data"]) {
          hanleAuthUserinfo({
            ...authUserinfo,
            ...resData["data"]["data"][0],
            loadData: true
          });
        } else {
          // setUserInfo({ ...userinfo, ...customData });
          customToastify("info", resData["message"], 3000, "top-center");
        }
      }
    } catch (error) {
      const errData = checkErrorMessage(error);
      customToastify("error", errData["titles"] || errData["message"], 3000, "top-center");
      console.error(error);
    }
  };

  const handleClickChangePassword = async () => {
    // const toastMsg = toast.loading("لطفا صبر کنید...")

    try {
      if (password.length < 8) setErrorPassword("کلمه عبور حداقل 8 کاراکتر باید باشد")
      else if (password !== repeatPassword) setErrorPassword("کلمه عبور و تکرار آن یکسان نیست")
      else {
        await toast.promise(setPasswordApi({ userPassword: password, confirmUserPassword: repeatPassword }), {
          pending: "لطفا صبر کنید",
          success: "اطلاعات با موفقیت بارگزاری شد",
          error: "مشکلی  وجود دارد 🤯",
        });
      }

    } catch (error) {
      const errData = checkErrorMessage(error);
      customToastify("error", errData["titles"] || errData["message"], 3000, "top-center");
    }

  }


  const handleClickCheckRefferal = async () => {
    // const toastMsg = toast.loading("لطفا صبر کنید...")

    try {
      if (marketingCode.length < 1) {
        setMessage({
          status: false,
          marketingCode: "",
          message: "لطفا ابتدا کد را وارد کنید",
        });
        return false;
      }
      setMessage({
        status: false,
        marketingCode: "",
        message: "لطفا صبر کنید",
      });
      const response = await toast.promise(
        checkRefferlCodeForUseApi({ marketingCode, productId: "forRegister" }),
        {
          pending: "لطفا صبر کنید",
          success: "بررسی کد انجام شد",
          error: `مشکلی وجود دارد 🤯`,
        }
      );
      const checkResponse = checkResponseData(response);
      if (checkResponse["message"]) {
        customToastify("info", checkResponse["message"], 3000, "top-center");
        setMessage({
          status: true,
          marketingCode,
          message: checkResponse["message"],
        });
      } else console.log(response);
    } catch (error) {
      const checkError = checkErrorMessage(error);
      if (checkError["titles"]) {
        customToastify("error", checkError["titles"], 3000, "top-center");
        setMessage({
          status: false,
          marketingCode: "",
          message: checkError["titles"],
        });
      } else if (checkError["message"]) {
        customToastify("error", checkError["message"], 3000, "top-center");
        setMessage({
          status: false,
          marketingCode: "",
          message: checkError["message"],
        });
      } else console.error(error);
    }
  };

  const setReferralCode = async () => {
    // const toastMsg = toast.loading("لطفا صبر کنید...")

    try {
      if (!message.status) {
        customToastify("info", "لطفا ابتدا روی بررسی کلیک کنید", 3000, "top-center");
        return false;
      }
      const response = await toast.promise(
        setReferralCodeApi({ registerCode: message["marketingCode"] }),
        {
          pending: "لطفا صبر کنید",
          success: "بررسی کد انجام شد",
          error: `مشکلی در بارگزاری اطلاعات وجود دارد 🤯`,
        }
      );
      const checkResponse = checkResponseData(response);
      if (checkResponse["message"]) {
        customToastify("info", checkResponse["message"], 3000, "top-center");
        setMessage({
          status: true,
          marketingCode,
          message: checkResponse["message"],
        });
      } else console.log(response);
    } catch (error) {
      const checkError = checkErrorMessage(error);
      if (checkError["titles"]) {
        customToastify("error", checkError["titles"], 3000, "top-center");
        setMessage({
          status: false,
          marketingCode: "",
          message: checkError["titles"],
        });
      } else if (checkError["message"])
        customToastify("error", checkError["message"], 3000, "top-center");
      else console.error(error);
    }
  };

  const loginOutUser = () => {
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("token");
    window.location.href = "/googlelogin";
  }


  return (
    <>
      {!authUserinfo["loadData"] ? (
        <Box sx={{ textAlign: "center", width: "95%" }}>
          <CircularProgress size={100} />
          <Typography variant="h4" style={{ color: 'white' }}>
            درحال دریافت اطلاعات
          </Typography>
          <Typography variant="h6" style={{ color: 'white' }}>
            لطفا صبر کنید ...
          </Typography>
        </Box>
      ) : (
        <Box sx={{ textAlign: "center", width: "95%" }} >
          <Divider textAlign="center">
            {<Chip label="ورود/ثبت نام با موفقیت انجام شد" color="success" icon={<DoneIcon />} />}
          </Divider>
          <Link to="/" style={{ textDecoration: "none" }}>
            <Button variant="contained" color='info' size="small">
              برگشت به صفحه اصلی
            </Button>
          </Link>
          <Button variant="contained" color='info' size="small" onClick={() => { window.location.replace("https://forum.umlang.com") }}>
            انجمن
          </Button>
          {/* <Button
          onClick={loginOutUser}
          sx={{ m: .5 }} variant="contained" color='info' endIcon={<ExitToAppIcon />} size="small">خروج</Button> */}
          <DemoPaper sx={{ my: .5 }} elevation={3} variant="elevation">
            <Divider sx={{ width: "90%" }} textAlign="left">
              تنظیم کلمه عبور
            </Divider>
            <FormControl sx={{ m: 1 }} variant="filled">
              <InputLabel htmlFor="filled-adornment-password">کلمه عبور</InputLabel>
              <FilledInput
                id="filled-adornment-password"
                type={showPassword ? 'text' : 'password'}
                onChange={(e) => {
                  setErrorPassword(null)
                  setPassword(e.target.value)
                }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
            <FormControl sx={{ m: 1 }} variant="filled">
              <InputLabel htmlFor="filled-adornment-password-repeat">تکرار کلمه عبور</InputLabel>
              <FilledInput
                id="filled-adornment-password-repeat"
                type={showPasswordRepeat ? 'text' : 'password'}
                onChange={(e) => {
                  setErrorPassword(null)
                  setRepeatPassword(e.target.value)
                }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPasswordRepeat}
                      onMouseDown={handleMouseDownPasswordRepeat}
                      edge="end"
                    >
                      {showPasswordRepeat ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
            <Typography sx={{ color: "red", fontSize: "small" }}>{errorPassword}</Typography>
            <br />
            <Button onClick={handleClickChangePassword} sx={{ mt: 1 }} variant="contained" endIcon={<SaveIcon />}>ذخیره</Button>
          </DemoPaper>
          <DemoPaper sx={{ my: .5 }} variant="outlined">
            <Divider textAlign="left">تغییر نام کاربری</Divider>
            <Typography>
              {`نام کاربری قدیم : ${authUserinfo.userName}`}
            </Typography>
            <TextField sx={{ mt: 1 }} onChange={handlechangeUserName} size='small' label="نام کابری جدید" variant="filled" />
            <br />
            <Button sx={{ m: .5 }} onClick={checkUsernameValid} variant="outlined" color="info">بررسی</Button>
            <Button sx={{ m: .5 }} onClick={changeUserName} variant="contained" endIcon={<SaveIcon />}>ذخیره</Button>
          </DemoPaper>
          <DemoPaper sx={{ my: .5 }} elevation={4} variant="elevation">
            <Divider textAlign="left">کد معرف</Divider>
            {authUserinfo.registerCode ? <>
              <Typography>
                شما قبلا کد معرف را ثبت کرده اید
              </Typography>
              <Typography>
                {`کد معرف: ${authUserinfo.registerCode}`}
              </Typography>
            </> : <>
              <TextField
                value={marketingCode}
                size="small"
                name="registerCode"
                label="کد معرف ثبت نام"
                placeholder="کد معرف ثبت نام"
                type="text"
                onChange={(e) => {
                  setMarketingCode(e.target.value);
                }}
              />
              <Typography >{message["message"]}</Typography>
              <br />
              <Button sx={{ m: .5 }} onClick={handleClickCheckRefferal} variant="outlined" color="info">بررسی</Button>
              <Button sx={{ m: .5 }} variant="contained" endIcon={<SaveIcon />}>ذخیره</Button>
            </>}
          </DemoPaper>
        </Box>)}
    </>
  )
}


export default LogedInUser;
